import { render, staticRenderFns } from "./BlocoPotencialPSA.vue?vue&type=template&id=63043f5e&scoped=true&lang=pug"
import script from "./BlocoPotencialPSA.vue?vue&type=script&lang=js"
export * from "./BlocoPotencialPSA.vue?vue&type=script&lang=js"
import style0 from "./BlocoPotencialPSA.vue?vue&type=style&index=0&id=63043f5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63043f5e",
  null
  
)

export default component.exports